import store from '@/store'
import Axios from 'axios'
import { Message } from 'element-ui'
import { getQueryObject } from '@/utils/index'
import { getToken } from '@/utils/auth'

// 获取AK，请求头加入AK
const { AK } = getQueryObject()
if (AK) {
    Axios.defaults.headers.AK = AK;
}

// create an Axios instance
const service = Axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        if (getToken()) {
            config.headers['accessToken'] = getToken()
        }
        return config
    },
    error => {
        console.log(error) // for debug
        return Promise.reject(error)
    }
) 

// response interceptor
service.interceptors.response.use(
    async (response) => {
        const { errorMessage = true } = response.config
        const state = response.data.state;
        const code = response.data.code;

        if (state === 1000) {
            await store.dispatch("user/resetAll");
            const href = window.location.href
            window.location.href = `/login?redirect=${href}`;
        } else if (state === 0) {
            errorMessage && Message({
                message: response.data.mes,
                type: "error"
            })
        } else if (code && code !== 0) {
            errorMessage && Message({
                message: response.data.msg,
                type: "error"
            })
        }
        return response;
    },
    error => {
        const { errorMessage = true } = error.response.config
        if (!Axios.isCancel(error)) {
            // 处理错误
            errorMessage && Message({
                message: error,
                type: "error",
                duration: 5 * 1000
            })
        }
        /* Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        }) */
        return Promise.reject(error)
    }
)

export default service
